var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"empty-state"},[(_vm.$slots.icon)?_c('div',{staticClass:"empty-state__icon"},[_vm._t("icon")],2):_vm._e(),_c('div',{staticClass:"empty-state__text"},[_vm._v(" "+_vm._s(_vm.message)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }